<!-- <label class="selectedDate">{{events[0].date | date: 'dd MMMM yyyy' }} Events</label> -->
<div *ngFor="let item of events">
  <ng-container *ngIf="areaCode">
    <core-page-divs [areaCode]="areaCode" [text]="(events[0].date | date: 'dd MMMM yyyy')+' Events'" [divs]="divs"
      [filters]="filters" (selected)="onStatSelect($event)"></core-page-divs>
  </ng-container>
</div>
